import { useGetDealOpportunityReportingMetrics } from "@vega-api/generated/coinvest-deal-report-lp/coinvest-deal-report-lp";
import { useGetDealOpportunityReportingFinancialReturns } from "@vega-api/generated/coinvest-deal-reporting-financial-returns-lp/coinvest-deal-reporting-financial-returns-lp";
import { ReportingHistorySection } from "@vega-modules/scenes/CoInvestmentsGP/pages/components/ReportingHistorySection";

import { DealOutcomeSection } from "./DealOutcomeSection";
import { MoicTrendSection } from "./MoicTrendSection";
import { PositionSection } from "./PositionSection";

export function PerformanceReportTab({
  dealOpportunityId,
}: {
  dealOpportunityId: string;
}) {
  const {
    data: metrics,
    isError: isMetricsError,
    isPending: isMetricsPending,
    refetch: refetchMetrics,
  } = useGetDealOpportunityReportingMetrics(dealOpportunityId, {
    query: {
      enabled: !!dealOpportunityId,
      select: (response) => response.data,
    },
  });

  const {
    data: financialReturns,
    isError: isReturnsError,
    isPending: isReturnsPending,
    refetch: refetchReturns,
  } = useGetDealOpportunityReportingFinancialReturns(dealOpportunityId, {
    query: {
      enabled: !!dealOpportunityId,
      select: (response) => response.data,
    },
  });

  return (
    <div className="mt-6 flex flex-col gap-8 pb-52">
      <DealOutcomeSection
        isError={isMetricsError}
        isLoading={isMetricsPending}
        onRetry={refetchMetrics}
        outcome={metrics?.dealOutcome}
      />
      <PositionSection
        isError={isMetricsError}
        isLoading={isMetricsPending}
        onRetry={refetchMetrics}
        position={metrics?.position}
      />
      <MoicTrendSection
        data={financialReturns}
        isError={isReturnsError}
        isLoading={isReturnsPending}
        onRetry={refetchReturns}
      />
      <ReportingHistorySection
        data={financialReturns}
        isError={isReturnsError}
        isPending={isReturnsPending}
        onRetry={refetchReturns}
      />
    </div>
  );
}
